module.exports = __webpack_public_path__ + "img/CHARTS.9b253a4c.svg";